import * as Action from "./constants";

export function getAllCompanies() {
  return {
    type: Action.GET_ALL_COMPANY,
  };
}
export function createCompany(postData) {
  return {
    type: Action.CREATE_COMPANY,
    postData,
  };
}
/**
 * Delete data
 */
export function deleteCompany(id) {
  return {
    type: Action.DELETE_COMPANY,
    id,
  };
}
/**
 * Edit Company
 */
export function editCompany(id) {
  return {
    type: Action.EDIT_COMPANY,
    id,
  };
}
/**
 * Update Company
 */
export function updateCompany({ postData }) {
  return {
    type: Action.UPDATE_COMPANY,
    postData,
  };
}